import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Link, useLocation } from 'react-router-dom';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') {
      window.location.href = '/#' + id;
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-8">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img
              src="/logo-upline.png"
              alt="Upline Global Solutions"
              className="h-48 w-auto object-contain"
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-slate-700 hover:text-teal-600 font-medium transition-colors"
            >
              Home
            </Link>
            <Link
              to="/products"
              className="text-slate-700 hover:text-teal-600 font-medium transition-colors"
            >
              Products
            </Link>
            <button
              onClick={() => scrollToSection('services')}
              className="text-slate-700 hover:text-teal-600 font-medium transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('why-us')}
              className="text-slate-700 hover:text-teal-600 font-medium transition-colors"
            >
              Why Us
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-slate-700 hover:text-teal-600 font-medium transition-colors"
            >
              Contact
            </button>
          </nav>

          {/* CTA Button */}
          <div className="hidden md:block">
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-teal-600 hover:bg-teal-700 text-white transition-colors"
            >
              Get a Quote
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-slate-700 hover:text-teal-600 transition-colors"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-200">
            <nav className="flex flex-col space-y-4">
              <Link
                to="/"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-slate-700 hover:text-teal-600 font-medium transition-colors text-left"
              >
                Home
              </Link>
              <Link
                to="/products"
                onClick={() => setIsMobileMenuOpen(false)}
                className="text-slate-700 hover:text-teal-600 font-medium transition-colors text-left"
              >
                Products
              </Link>
              <button
                onClick={() => scrollToSection('services')}
                className="text-slate-700 hover:text-teal-600 font-medium transition-colors text-left"
              >
                Services
              </button>
              <button
                onClick={() => scrollToSection('why-us')}
                className="text-slate-700 hover:text-teal-600 font-medium transition-colors text-left"
              >
                Why Us
              </button>
              <button
                onClick={() => scrollToSection('contact')}
                className="text-slate-700 hover:text-teal-600 font-medium transition-colors text-left"
              >
                Contact
              </button>
              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-teal-600 hover:bg-teal-700 text-white w-full transition-colors"
              >
                Get a Quote
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};